module.exports = __webpack_public_path__ + "img/boughts.51a09bc1.svg";